import React from 'react';
import { Grid } from '@mui/material';
import CustomCard2 from '../../components/cards/CustomCard2';
import AdminsSidebar from '../../components/sidebars/AdminsSidebar';
import PageLayout from '../layouts/PageLayout';
import ManagerWidget from '../../components/widgets/ManagerWidget';
import { useGetAllManagersQuery } from '../../api/users/userAPI';
import { useDispatch, useSelector } from 'react-redux';
import { setManagers } from '../../features/userSlice';
import { map, size } from 'lodash';
import CountBadge from '../../components/CountBadge';

// !############### MAIN FUNC ####################
const Admins = () => {
    const dispatch = useDispatch();
    const { data: managers, isSuccess, isError } = useGetAllManagersQuery();

    if (isError) {
        dispatch(setManagers({ managers: [] }));
    }

    if (isSuccess) {
        dispatch(setManagers({ managers: managers.data }));
    }

    const admins = useSelector((state) => state.users.managers);

    return (
        <>
            <PageLayout sidebar={<AdminsSidebar />} head="Managers managements">
                <CustomCard2
                    title={`CAICA Managers`}
                    heightClear={640}
                    action={
                        <CountBadge total={size(admins)} item={'Admins'} />
                    }
                >
                    <Grid container spacing={3} padding={2}>
                        {map(admins, (admin, index) => (
                            <Grid item sm={3} key={index}>
                                <ManagerWidget manager={admin} />
                            </Grid>
                        ))}
                    </Grid>
                </CustomCard2>
            </PageLayout>
        </>
    );
};

export default Admins;
